import { apiClient } from './client'

export type MediaAsset = {
  id: string
  url: string
  contentType: string
  fileName: string
  sizeBytes: number
  uploadedBy: string
  createdAtUtc: string
}

export async function getMediaAssets(limit = 100): Promise<MediaAsset[]> {
  const { data } = await apiClient.get<MediaAsset[]>('/api/admin/media-assets', {
    params: { limit }
  })
  return data
}

export async function uploadMediaAsset(file: File): Promise<MediaAsset> {
  const formData = new FormData()
  formData.append('file', file)

  const { data } = await apiClient.post<MediaAsset>('/api/admin/media-assets/upload', formData)
  return data
}

export async function deleteMediaAsset(id: string): Promise<void> {
  await apiClient.delete(`/api/admin/media-assets/${id}`)
}
